import { render, staticRenderFns } from "./EiWord.vue?vue&type=template&id=4e45a98a&scoped=true&"
import script from "./EiWord.vue?vue&type=script&lang=js&"
export * from "./EiWord.vue?vue&type=script&lang=js&"
import style0 from "./EiWord.vue?vue&type=style&index=0&id=4e45a98a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45a98a",
  null
  
)

export default component.exports